export const COMPANY = {
  name: "Powercom S.r.l.",
  vat: "P.IVA 10280401216",
  legal: "Sede Legale: Via Archi Augustei, 99 · Sant'Anastasia (NA)",
  operational: "Sede Operativa: Via Bosco, 71 · Somma Vesuviana (NA)",
  logoUrl: "https://customer-assets.emergentagent.com/job_warehouse-tracker-108/artifacts/zym4rjh7_Logo%20%5BCMYK%5D%20PNG%201%20Colore.webp",
};
